interface Currency {
  displayName: string;
  numericCode: number;
  defaultFractionDigits: number;
  subUnit: number;
  symbolSpaced: boolean;
  symbolPosition: "after" | "before";
  symbol: string;
  isoCode: "ILS";
};

const ILS: Currency = Object.freeze({
  "displayName": "New Israeli Sheqel",
  "numericCode": 376,
  "defaultFractionDigits": 2,
  "subUnit": 100,
  "symbolSpaced": true,
  "symbolPosition": "before",
  "isoCode": "ILS",
  "symbol": "₪"
});

export { ILS };
